import * as React from "react";
import { session } from "clientInstance";
import { connect, MapStateToProps } from "react-redux";
import GlobalState from "globalState";
import { ConfigurationFeaturesState } from "areas/configuration/reducers/configurationArea";

export enum Feature {
    MultiTenancy,
    CommunityActionTemplates,
    BuiltInRepoSync
}

interface ConnectedProps {
    features: ConfigurationFeaturesState;
}

interface FeatureToggleProps {
    feature: Feature;
    enabled?: boolean;
}

const FeatureToggle: React.StatelessComponent<FeatureToggleProps & ConnectedProps> = props => {
    let featureStatus: boolean;

    switch (props.feature) {
        case Feature.MultiTenancy:
            featureStatus = props.features.isMultiTenancyEnabled;
            break;
        case Feature.CommunityActionTemplates:
            featureStatus = props.features.isCommunityActionTemplatesEnabled;
            break;
        case Feature.BuiltInRepoSync:
            featureStatus = props.features.isBuiltInRepoSyncEnabled;
            break;
    }

    if ((featureStatus && props.enabled) || (!featureStatus && !props.enabled)) {
        return (
            <span>
                {props.children}
            </span>
        );
    }

    return null;
};

FeatureToggle.defaultProps = { enabled: true };

const mapStateToProps: MapStateToProps<ConnectedProps, FeatureToggleProps> = (state: GlobalState) => {
    return {
        features: state.configurationArea.features
    };
};

export default connect(mapStateToProps)(FeatureToggle);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/FeatureToggle/FeatureToggle.tsx